import { Component, OnInit, Inject , ViewChild} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmPasswordService } from '../../services/confirm-password.service';
import { FormValidatorService } from '../../services/form-validator.service';
import { LanguageService } from '../../services/language.service';
import { Validators } from '../../validators';
import { MsgProvider, TwoFactorAuthOtpService } from '../../services/two-factor-auth/two.factor.auth.service';
import { GetBusinessProfileService } from '../../services/get-business-profile.service';
import { CountdownTimerComponent } from '../countdown-timer/countdown-timer.component';
@Component({
  selector: 'app-password-confirm',
  templateUrl: './password-confirm.component.html',
  styleUrls: ['./password-confirm.component.scss'],
})
export class PasswordConfirmComponent implements OnInit {
  @ViewChild(CountdownTimerComponent) countdownTimer: CountdownTimerComponent;
  // Form variables
  formValidator: FormValidatorService = new FormValidatorService();
  confirmPasswordForm!: FormGroup;

  // Password Icon Toggle
  message: any;
  messageUrgent: any;
  normalFees: any = 15;
  urgentFees: any = 50;
  recurringFees: number = 20;
  passwordHide: boolean = true;
  showOtp: boolean = true;
  operation: string;
  showResendOtp: boolean = false;
  userphone: number ;
  constructor(
    public dialogRef: MatDialogRef<PasswordConfirmComponent>,
    private confirmPass: ConfirmPasswordService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    public languageService: LanguageService,
    private twoFactorAuthOtpService: TwoFactorAuthOtpService,
    private getBusinessProfileService: GetBusinessProfileService
  ) {
    this.showOtp =
    this.data?.showOtp != null ? this.data.showOtp : this.showOtp;
    this.operation = this.data?.operation;
  }

  async ngOnInit() {
    if (localStorage.getItem('language')) {
      this.translate.use(localStorage.getItem('language'));
    }
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
    });
    if (this.data) {
      this.normalFees = this.data.normalFees ?? this.normalFees;
      this.urgentFees = this.data.urgentFees ?? this.urgentFees;
    }
    this.formValidator = new FormValidatorService();
    const form = [
      {
        fieldName: 'password',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: Validators.minLength(6),
            message: '',
          },
        ],
      },
    ];
    const otpInput = {
      fieldName: 'otp',
      defaultValue: '',
      validators: [
        {
          validatorFn: Validators.required,
          message: this.translate.instant('FORMS.TWOFACTORAUTH.OTP.REQUIRED'),
        },
      ],
    };
    this.showOtp ? form.push(otpInput) : null;
    this.confirmPasswordForm = this.formValidator.createForm(form);
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    });
    if(this.showOtp){
      const user = await this.getBusinessProfileService.make();
      this.userphone = user?.phone.replace(/.(?=.{4})/g, '*');
      this.normalFees = user.Business.normalFees
      this.urgentFees = user.Business.urgentFees
     }
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        password: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Password',
            fieldAr: 'كلمة المرور',
          }),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: 'password',
            fieldAr: 'كلمة المرور',
            value: 6,
          }),
        },
        otp: {
          required: this.translate.instant('FORMS.TWOFACTORAUTH.OTP.REQUIRED'),
        },
      };
    });
  }

  async onSubmit() {
    this.confirmPass.setParams(this.confirmPasswordForm.value);
    try {
      const result = await this.confirmPass.make();
      const otp = this.confirmPasswordForm.value.otp;
      if (this.showOtp && !otp) throw new Error('Invalid Otp');
      this.dialogRef.close({ status: true, otp: otp });
    } catch (err) {
      console.log(err);
      this.formValidator.addError('password', 'invalid', 'password incorrect');
      this.confirmPasswordForm.controls['password'].setErrors({
        invalid: 'invalid',
      });
      this.formValidator.ShowErrors();
    }
  }

  cancel() {
    this.dialogRef.close(false);
  }
  onRemainingTimeChange(remainingTime: number): void {
    if (remainingTime === 0) {
      this.showResendOtp = true;
    }
  }
  async resendOtp(msgProvider: MsgProvider = "SMS") {
    try {
      await this.twoFactorAuthOtpService.sendOtp(this.operation, msgProvider);
    } catch (err) {
      this.twoFactorAuthOtpService.handleErrors(err);
    }
    this.showResendOtp = false;
    this.countdownTimer.resetTimer();
  }
}
